import { NewRelicBrowserAppConfigInput, NewRelicBrowserConfig } from "./types";

export const parseBooleanConfig = (value: string | null | undefined): boolean => {
  if (!value) {
    return false;
  }

  const normalized = String(value).trim().toLowerCase();

  return normalized === "true" || normalized === "1";
};

const parseRequiredString = (value: string | null | undefined): string | null => {
  if (value === null || value === undefined) {
    return null;
  }

  const trimmed = String(value).trim();

  return trimmed || null;
};

const parseRequiredNumericString = (value: string | null | undefined): string | null => {
  const trimmed = parseRequiredString(value);

  if (!trimmed || !/^\d+$/.test(trimmed)) {
    return null;
  }

  return trimmed;
};

export const parseNewRelicBrowserConfig = (config: NewRelicBrowserAppConfigInput): NewRelicBrowserConfig | null => {
  if (!parseBooleanConfig(config.enabled)) {
    return null;
  }

  const licenseKey = parseRequiredString(config.licenseKey);
  const beacon = parseRequiredString(config.beacon);
  const applicationId = parseRequiredNumericString(config.applicationId);
  const accountId = parseRequiredNumericString(config.accountId);
  const trustKey = parseRequiredNumericString(config.trustKey);
  const agentId = parseRequiredNumericString(config.agentId);

  if (!licenseKey || !beacon || !applicationId || !accountId || !trustKey || !agentId) {
    return null;
  }

  return {
    applicationId,
    licenseKey,
    accountId,
    trustKey,
    agentId,
    beacon
  };
};
